import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#010101",
		d: "m266.04 260.43 118.43-118.48 4.06-4.53c21.28-26.13 21.28-64.08-.88-91.23l-3.18-3.51q-.825-.915-1.74-1.74l-4.49-4.04c-2.11-1.72-4.41-3.08-6.67-4.52-1.54-2.4-2.99-4.83-4.84-7.1l-3.36-3.57a6.4 6.4 0 0 0-1.68-1.68l-4.41-4.2c-26.27-21.22-64.09-21.22-90.36 0-.21.42-.63.63-.84.84L93.54 188.98c-27.95 27.74-27.95 73.13 0 100.87l20.13 20.13c.3.31.49.67.8.98l169.02 168.96 4.49 4.04c13.13 10.71 28.94 16.05 44.8 16.05 18.57 0 37.21-7.31 51.69-21.84l4.06-4.51c21.28-26.14 21.28-64.07-.88-91.22l-121.61-122Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M328.48 394.29c6.09 7.56 6.09 18.91.84 25.43l-2.31 2.73c-7.78 7.56-19.75 8.19-27.11 2.31L129.05 254.33c-8.19-8.2-8.19-21.65 0-29.84L296.33 57.22l2.94-2.52c7.56-5.88 18.49-5.88 25.01-.63l4.2 3.99c6.09 7.56 6.09 18.91.84 25.43L191.47 221.55c-9.88 9.88-9.88 25.85 0 35.72l134.7 134.49 2.31 2.52Z"
	})]
});
export default SvgBackArrow;
